import {IAbstractModule, IModuleType} from "@/model/Locker/IModule";

export const ModuleMix: IAbstractModule = {
  type: IModuleType.mix,
  name: 'Mix 12',
  hasScreen: false,
  columns: [
    [
      {
        name: "5",
        connector: "5",
        cell_size_id: 1,
        accessible: false,
      },
      {
        name: "13",
        connector: "13",
        cell_size_id: 3,
        accessible: true,
      },
      {
        name: "14",
        connector: "14",
        cell_size_id: 3,
        accessible: true,
      },
      {
        name: "15",
        connector: "15",
        cell_size_id: 3,
        accessible: true,
      },
      {
        name: "16",
        connector: "16",
        cell_size_id: 3,
        accessible: true,
      },
      {
        name: "18",
        connector: "18",
        cell_size_id: 4,
        accessible: false,
      },
    ],
    [
      {
        name: "1",
        connector: "1",
        cell_size_id: 1,
        accessible: false,
      },
      {
        name: "9",
        connector: "9",
        cell_size_id: 3,
        accessible: true,
      },
      {
        name: "10",
        connector: "10",
        cell_size_id: 3,
        accessible: true,
      },
      {
        name: "11",
        connector: "11",
        cell_size_id: 3,
        accessible: true,
      },
      {
        name: "12",
        connector: "12",
        cell_size_id: 3,
        accessible: true,
      },
      {
        name: "17",
        connector: "17",
        cell_size_id: 4,
        accessible: false,
      },
    ]
  ]
};
